import React, { useEffect } from "react";
import { useInstitutionsServices } from "@/features/institutions/hooks/use-institutions-services";
import { BaseRoundButton } from "@/shared/components/button/base-round-button";
import { useInstitutionsContext } from "@/features/institutions/contexts/institutions-context";
import { useAddNewAccount } from "@/features/home/hooks/use-add-new-account";


export const InstitutionsServicesList = () => {
  const {
    selectedInstitution,
    institutionsServices,
    setSelectedInstitutionService,
  } = useInstitutionsContext();

  const {
    getInstitutionsServices,
  } = useInstitutionsServices();
  const {
    openAuthorizationModals,
  } = useAddNewAccount();

  useEffect(() => {
    if (selectedInstitution) {
      getInstitutionsServices(
        selectedInstitution.industryCode,
        selectedInstitution.companyCode,
        selectedInstitution.branchCode,
      );
    }
  }, [selectedInstitution]);

  return (
    <nav>
      {/* 金融機関サービス一覧 */}
      {institutionsServices.map((institutionsService) => (
        <BaseRoundButton
          key={institutionsService.serviceCode}
          buttonText={institutionsService.serviceName}
          onClick={() => {
            setSelectedInstitutionService(institutionsService)
            openAuthorizationModals(institutionsService)
          }}
        />
      ))}
    </nav>
  );
};
